// eslint-disable-next-line import/no-unresolved
import phoneCalendarIcon from 'assets/icons/hero/phone-calendar.svg';
import phoneMagicIcon from 'assets/icons/hero/phone-magic.svg';
import phoneMicrophoneIcon from 'assets/icons/hero/phone-microphone.svg';
import hero1Image from 'assets/img/hero-1.webp';
import hero2Image from 'assets/img/hero-2.webp';
import person1Image from 'assets/img/person-1.webp';
import person2Image from 'assets/img/person-2.webp';
import person3Image from 'assets/img/person-3.webp';

export const dataHero = {
  heading: 'über 100 Praxen nutzen FOXI',
  title: 'Abrechnung mit KI',
  description:
    'Automatische Abrechnung und Dokumentation für das ganze Team in Deiner Zahnarztpraxis',
  button: {
    title: 'Termin vereinbaren',
    href: 'https://calendly.com/foxi-abrechnung/30min',
    icon: 'arrow-right',
  },
  images: {
    image1: hero1Image,
    image2: hero2Image,
  },
  testimonials: [
    {
      name: 'Dr. Imraish-Ali',
      role: 'Zahnärztin, nutzt FOXI seit 2024',
      image: person3Image,
      description:
        'Mit FOXI ist das Thema Dokumentation und Abrechnung endlich komplett gelöst. Genau dieses Tool habe ich lange gesucht.',
    },
    {
      name: 'Elitsa Filipova',
      role: 'Zahnärztin, nutzt FOXI seit 2024',
      image: person2Image,
      description:
        'Mit FOXI reduziert sich der Zeitaufwand enorm und die Qualität der Einträge ist viel besser und einheitlicher als vorher.',
    },
    {
      name: 'Emile Weekers',
      role: 'Chairman, Fair Doctors, nutzt FOXI seit 2024 in 25 Praxen',
      image: person1Image,
      description:
        'Foxi unterstützt uns für eine bessere Qualität von Dokumentation und Abrechnung in allen unseren Standorten.',
    },
  ],
  tips: [
    {
      icon: phoneMagicIcon,
      title: 'KI-Telefonassistent für Deine Rezeption',
      details:
        'Wer kennt nicht den Stress an der Anmeldung? Lass einfach bei Bedarf die KI das Telefon beantworten. Rezeption und Praxis sind 24/7 für Deine Patienten da.',
    },
    {
      icon: phoneCalendarIcon,
      title: 'Nahtlose Integration in Dein PVS',
      details:
        'Alle Positionen, Faktoren, Faktorbegründungen und die Dokumentation werden übertragen. Keine manuelle Eingabe von Positionen mehr nötig!',
    },
    {
      icon: phoneMicrophoneIcon,
      title: 'Dokumentation per Sprache mit Handy oder PC',
      details:
        'Ideal für Aufklärungsgespräche, ZE-Besprechungen usw. Einfach Mikrofon anschalten und FOXI filtert die Aufnahme nach wichtigen Inhalten und fasst sie intelligent zusammen.',
    },
  ],
};
